import client from './client';
import {
  CrewLiveStatusResponse,
  CrewSupervisorsResponse,
} from '../interfaces/CrewLiveStatus';

/**
 * API client for the Home "My Crew — Live Status" / "Crew Map" widgets
 * (docs/featureBriefs/design_handoff_home_crew/API_CONTRACT.md).
 */

/**
 * GET /admin/crew/liveStatus — current punch status for the caller's crew.
 * `supervisorEmployeeID` is honored only for super admins (server ignores it
 * otherwise); omit it for regular supervisors.
 */
export const getCrewLiveStatus = async (
  supervisorEmployeeID?: number,
): Promise<CrewLiveStatusResponse> => {
  const params: Record<string, number> = {};
  if (supervisorEmployeeID) params.supervisorEmployeeID = supervisorEmployeeID;
  const response = await client.get('/admin/crew/liveStatus', { params });
  return response.data;
};

/**
 * GET /admin/crew/supervisors — active supervisors with ≥1 active crew member,
 * sorted by last name. Super admin only (powers the supervisor picker).
 */
export const getCrewSupervisors = async (): Promise<CrewSupervisorsResponse> => {
  const response = await client.get('/admin/crew/supervisors');
  return response.data;
};
